import {BASE_URL} from '../../config/constant.js';

if (!window.location.pathname.includes(BASE_URL)) {
  window.history.replaceState('', '', BASE_URL + window.location.pathname);
}
